import { computed } from "vue";
import { BadgeType } from "../interfaces/index.js";
function useChargemapMessageStyles(type) {
  const containerBackgroundClass = computed(() => {
    switch (type) {
      case BadgeType.NEUTRAL:
        return "bg-badge-neutral";
      case BadgeType.SUCCESS:
        return "bg-badge-positive";
      case BadgeType.WARNING:
        return "bg-badge-warning";
      case BadgeType.ERROR:
        return "bg-badge-negative";
      case BadgeType.INFO:
      default:
        return "bg-badge-info";
    }
  });
  const messageClass = computed(() => {
    switch (type) {
      case BadgeType.NEUTRAL:
        return "text-badge-neutral";
      case BadgeType.SUCCESS:
        return "text-badge-positive";
      case BadgeType.WARNING:
        return "text-badge-warning";
      case BadgeType.ERROR:
        return "text-badge-negative";
      case BadgeType.INFO:
      default:
        return "text-badge-info";
    }
  });
  const iconClass = computed(() => {
    switch (type) {
      case BadgeType.NEUTRAL:
        return "text-icon-secondary-neutral";
      case BadgeType.SUCCESS:
        return "text-icon-secondary-positive";
      case BadgeType.WARNING:
        return "text-icon-secondary-warning";
      case BadgeType.ERROR:
        return "text-icon-secondary-negative";
      case BadgeType.INFO:
      default:
        return "text-icon-secondary-branding";
    }
  });
  const actionSlotClass = computed(() => {
    switch (type) {
      case BadgeType.NEUTRAL:
        return "text-button-tertiary-neutral";
      case BadgeType.SUCCESS:
        return "text-button-tertiary-positive";
      case BadgeType.WARNING:
        return "text-button-tertiary-warning";
      case BadgeType.ERROR:
        return "text-button-tertiary-negative";
      case BadgeType.INFO:
      default:
        return "text-button-tertiary-branding";
    }
  });
  return {
    containerBackgroundClass,
    messageClass,
    iconClass,
    actionSlotClass
  };
}
export default useChargemapMessageStyles;
